import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import PickupApp from './pickup/PickupApp'
import { UserProvider } from './contexts/UserContext'
import { LeagueProvider } from './contexts/LeagueContext'
import { ToastProvider } from './contexts/ToastContext'
import { isPickupSubdomain } from './lib/utils'
import './index.css'

// pickup.iceops.app is a standalone surface - it bypasses the org/league app shell
// (and its providers) entirely.
const root = ReactDOM.createRoot(document.getElementById('root'))

if (isPickupSubdomain()) {
  root.render(
    <React.StrictMode>
      <PickupApp />
    </React.StrictMode>,
  )
} else {
  root.render(
    <React.StrictMode>
      <UserProvider>
        <LeagueProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </LeagueProvider>
      </UserProvider>
    </React.StrictMode>,
  )
}
